import React, { forwardRef, useState } from 'react';

import ReactSelect from 'react-select';

export const selectCustomStyles = {
    container: (provided, state) => ({
        ...provided,
        width: '100%',
    }),
    valueContainer: (provided, state) => ({
        ...provided,
        height: "48px"
    }),
    control: (styles) => ({ ...styles, backgroundColor: '#F9FAFB', width: "100%", borderRadius: "12px", borderColor: "#E1E7EC" }),

    singleValue: (styles) => ({ ...styles, color: "#809FB8" }),
    placeholder: (styles) => ({ ...styles, color: "#c0cfdc" }),
    menu: (def) => ({ ...def, }),
}

/**
 * For isMulti selects. The shared style above fixes the value container at 48px with no
 * overflow, so once a few chips are selected the rest are clipped and unreachable (the
 * "Excluded Interpreters box only shows 4 and won't scroll" report). This lets the box
 * grow and then scroll instead.
 */
export const multiSelectCustomStyles = {
    ...selectCustomStyles,
    valueContainer: (provided) => ({
        ...provided,
        minHeight: "48px",
        height: "auto",
        maxHeight: "120px",
        overflowY: "auto",
        flexWrap: "wrap",
        alignItems: "flex-start",
        paddingTop: "6px",
        paddingBottom: "6px",
    }),
    control: (styles) => ({
        ...styles,
        backgroundColor: '#F9FAFB',
        width: "100%",
        borderRadius: "12px",
        borderColor: "#E1E7EC",
        minHeight: "48px",
        height: "auto",
    }),
}

export const Select = forwardRef(({
    options,
    onChange,
    value,
    label,
    name,
    loading,
    placeholder = "Select ...",
    disabledSearch = false,
    isClearable = true,
    isDisabled,
    onStateChanges,
    defaultValues
}, ref
) => {
    // const [isLoading, setIsLoading] = useState(false);
    const [isRtl, setIsRtl] = useState(false);
    const [selectedValue, setSelectedValue] = useState(options[0])

    return (
        <>
            <ReactSelect
                styles={selectCustomStyles}
                defaultValue={defaultValues && defaultValues}
                value={value}
                onChange={(newValue) => {
                    onStateChanges && onStateChanges(newValue)
                    onChange(newValue ? newValue.value : undefined);
                    setSelectedValue(newValue);
                }}
                className="basic-single"
                classNamePrefix="select"
                isDisabled={isDisabled}
                isLoading={loading}
                isClearable={isClearable}
                isRtl={isRtl}
                placeholder={placeholder}

                isSearchable={!disabledSearch}
                name={name}
                options={options}
                ref={ref}
                menuPlacement='auto'


            />

        </>
    );
})